import useCalendarStore from '@/store/calendarStore';
import { SELECT_TYPE, CALENDAR_ITEM_COLOR } from '@/constants/calendar';
import ColorBox from '../ui/ColorBox';
import { isMobile } from 'react-device-detect';

const EventCheckBox = () => {
  const { checkedEvent, setCheckedEvent } = useCalendarStore();
  const handleCheckboxChange = event => {
    const { name, checked } = event.target;
    setCheckedEvent({ ...checkedEvent, [name]: checked });
  };

  const getCheckboxStyle = (type: string) => {
    if (!isMobile) return {};
    return {
      width: '16px',
      height: '16px',
      accentColor: type === 'GLOBAL' ? '#87CEEB' : '#fccb16',
    };
  };

  return (
    <section
      className={`flex flex-wrap max-w-[50%] flex-[0.8] ${
        isMobile
          ? 'flex-row items-center justify-between flex-nowrap gap-2 max-w-full flex-1'
          : ''
      }`}
    >
      {SELECT_TYPE.map((type, index) => {
        return (
          <label
            key={index}
            className={`flex items-center gap-2 mr-2.5 font-medium whitespace-nowrap text-base ${
              isMobile ? 'justify-center !text-sm' : ''
            }`}
          >
            <input
              type='checkbox'
              name={type}
              checked={checkedEvent[type]}
              onChange={handleCheckboxChange}
              className='text-base ml-0'
              style={getCheckboxStyle(type)}
            />
            {!isMobile && <ColorBox color={CALENDAR_ITEM_COLOR[type]} />}
            {type}
          </label>
        );
      })}
    </section>
  );
};

export default EventCheckBox;
